"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React from "react";
import ErrorBoundary from "../../components/error_boundary";
import IgnoreEntryWrapper from "../ignore_entry_wrapper";
import { ElementRoot } from "./element_root";
const DOCUMENT_BATCH_ID_ATTR = "document-batch-id";
const TAG = "ht-ignore-entry";
class IgnoreEntryElement extends HTMLElement {
  constructor() {
    super(...arguments);
    __publicField(this, "root", new ElementRoot(this));
  }
  static get observedAttributes() {
    return [DOCUMENT_BATCH_ID_ATTR];
  }
  connectedCallback() {
    this.renderFromAttributes();
  }
  attributeChangedCallback(name) {
    if (name === DOCUMENT_BATCH_ID_ATTR) {
      this.renderFromAttributes();
    }
  }
  disconnectedCallback() {
    this.root.unmountSoon();
  }
  renderFromAttributes() {
    const documentBatchId = this.getAttribute(DOCUMENT_BATCH_ID_ATTR);
    if (!documentBatchId) return;
    this.root.render(
      React.createElement(
        ErrorBoundary,
        { name: "ignore-entry" },
        React.createElement(IgnoreEntryWrapper, {
          documentBatchId: parseInt(documentBatchId, 10),
          onComplete: () => {
            this.dispatchEvent(
              new CustomEvent("ignore-complete", { bubbles: true })
            );
          },
          onCancel: () => {
            this.dispatchEvent(
              new CustomEvent("ignore-cancelled", { bubbles: true })
            );
          }
        })
      )
    );
  }
}
if (!customElements.get(TAG)) {
  customElements.define(TAG, IgnoreEntryElement);
}
